export default class ClockRecordModel {
  constructor() {
    this.eventType = null;
    this.description = null;
  }
}
